import Address from '../AddressBuilder.js'
import HttpConfig from '../../request/HttpConfig'

const _path = {
  SYS: Address.sys('sys/file'),
}

export default {

  configBuilder: HttpConfig.obtain().closeLoading(),

  multFormDataConfig: HttpConfig.obtain().closeLoading().addHeader('Content-Type', 'multipart/form-data').done(),

  uploadFile(_parameter, onProgress) {// 上传文件
    let config
    if (typeof onProgress === 'function') {
      config = this.configBuilder.setOnUploadProgress(onProgress).done()
    }
    return sHttp.postJson(_path.SYS + 'upload', _parameter, config)
  },

  uploadImg(_parameter, onProgress) {
    let config
    if (typeof onProgress === 'function') {
      config = this.configBuilder.setOnUploadProgress(onProgress).done()
    }
    return sHttp.postJson(_path.SYS + 'uploadImg', _parameter, config)
  },

  uploadRemove(url) {// 上传删除
    let _parameter = {url: url}
    return sHttp.postJson(_path.SYS + 'remove', _parameter)
  },

  uploadEditUploadImg(file, type) {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('type', type)
    return sHttp.postJson(_path.SYS + 'upload', formData, this.multFormDataConfig)
  },

  uploadChunk(file, chunk, chunks, md5) {
    let formData = new FormData()
    formData.append('file', file)
    formData.append('chunk', chunk)
    formData.append('chunks', chunks)
    formData.append('md5', md5)

    let config = HttpConfig
      .obtain()
      .closeLoading()
      .addConfig('timeout', 20 * 1000)
      .addHeader('Content-Type', 'multipart/form-data')
      .done()
    return sHttp.postJson(_path.SYS + 'uploadChunk', formData, config)
  },

  mergeChunk(md5, size, contentType, chunks, filename) {
    let formData = new FormData()
    formData.append('md5', md5)
    formData.append('size', size)
    formData.append('contentType', contentType)
    formData.append('chunks', chunks)
    formData.append('filename', filename)

    return sHttp.postJson(_path.SYS + 'mergeChunk', formData, this.multFormDataConfig)

  },

  deleteChunks(md5) {
    let formData = new FormData()
    formData.append('md5', md5)

    return sHttp.postJson(_path.SYS + 'deleteChunks', formData, this.multFormDataConfig)
  },

  deleteFile(md5) {
    let formData = new FormData()
    formData.append('md5', md5)

    return sHttp.postJson(_path.SYS + 'deleteFile', formData, this.multFormDataConfig)
  }
}


